import phone1 from "../assets/images/phone/1.png";
import phone2 from "../assets/images/phone/2.png";
import phone3 from "../assets/images/phone/3.png";
import phone4 from "../assets/images/phone/4.png";
import phone5 from "../assets/images/phone/5.png";
import phone6 from "../assets/images/phone/6.png";
import phone7 from "../assets/images/phone/7.png";
import phone8 from "../assets/images/phone/8.png";

export const screenshotImg = [
  phone1,
  phone2,
  phone3,
  phone4,
  phone5,
  phone6,
  phone7,
  phone8,
];
